import type { ManualAnchor } from '../types/manual-anchor'
import type { ScreenPoint, ScreenRect } from '../types/screen-rect'
import { clampToLiveAreaX, clampToLiveAreaY } from './clamp-to-live-area'
import { nudgeOutOfTheWay } from './nudge-out-of-the-way'

/**
 * Once the user has manually placed the toolbar, keep it at the same offset from the object as
 * the viewport pans/zooms — but if the shape being edited (e.g. while dragging a node) comes to
 * overlap it, nudge it just clear of the shape instead of jumping back to the fully
 * auto-computed position.
 */
export function resolveManualDisplayPos(
  manualAnchor: ManualAnchor,
  canvasRect: DOMRect,
  scale: number,
  width: number,
  height: number,
  shapeRect: ScreenRect
): ScreenPoint {
  // Stored as a document-space anchor plus a pixel offset, so a dragged bar follows pan AND
  // zoom instead of sticking to a screen point.
  const anchorScreenX = canvasRect.left + manualAnchor.docX * scale
  const anchorScreenY = canvasRect.top + manualAnchor.docY * scale
  const manualPos = {
    x: clampToLiveAreaX(anchorScreenX + manualAnchor.offsetX, width),
    y: clampToLiveAreaY(anchorScreenY + manualAnchor.offsetY, height),
  }

  return nudgeOutOfTheWay(manualPos, shapeRect, width, height)
}
